import React from 'react';
import { Link } from 'react-router-dom';

function PaymentHxPopup({ closePopup1 }) {
  return (
    <div className="modalBackground">
      <div className="appt-hx-contnr pymnt-hx-main-con 7hide">
        <div className="appt-hx-hdr-pt-info">
          <span className="rc-pt-nm">
            <b>Payment History: </b> Kashif, Mohd <span className="red">|</span>{' '}
            ID: 1162 <span className="red">|</span> 25 yrs-[F]{' '}
            <span className="red">|</span> DOB:06-30-1992
          </span>
          <span className="right red bold" onClick={closePopup1}>
            X
          </span>
        </div>
        <div className="pymnt-hx-hdr">
          <span className="phx-col">ID</span>
          <span className="phx-col">Payment</span>
          <span className="phx-col">Payment for</span>
          <span className="phx-col">Mode</span>
          <span className="phx-col">Check#</span>
          <span className="phx-col">Amount</span>
          <span className="phx-col">Action</span>
        </div>
        <div className="pymnt-hx-bdy">
          <div className="pymnt-hx-bdy-rw">
            <span className="phx-col">14268</span>
            <span className="phx-col">02-15-2023</span>
            <span className="phx-col">Counseling</span>
            <span className="phx-col">Check</span>
            <span className="phx-col">5269</span>
            <span className="phx-col">$125.00</span>
            <span className="phx-col">
              <Link>View</Link> | <Link href="#">Change</Link> |{' '}
              <Link href="#">Print</Link> | <Link href="#">Delete</Link>
            </span>
          </div>
          <div className="pymnt-hx-bdy-rw alt-rw">
            <span className="phx-col">13658</span>
            <span className="phx-col">08-11-2022</span>
            <span className="phx-col">Counseling</span>
            <span className="phx-col">Cash</span>
            <span className="phx-col">-</span>
            <span className="phx-col">$65.00</span>
            <span className="phx-col">
              <Link href="#">View</Link> | <Link href="#">Change</Link> |{' '}
              <Link href="#">Print</Link> | <Link href="#">Delete</Link>
            </span>
          </div>
          <div className="pymnt-hx-bdy-rw">
            <span className="phx-col">12569</span>
            <span className="phx-col">22-10-2022</span>
            <span className="phx-col">Counseling</span>
            <span className="phx-col">Check</span>
            <span className="phx-col">5269</span>
            <span className="phx-col">$65.00</span>
            <span className="phx-col">
              <Link href="#">View</Link> | <Link href="#">Change</Link> |{' '}
              <Link href="#">Print</Link> | <Link href="#">Delete</Link>
            </span>
          </div>
          <div className="pymnt-hx-bdy-rw alt-rw">
            <span className="phx-col">12501</span>
            <span className="phx-col">14-09-2022</span>
            <span className="phx-col">Counseling</span>
            <span className="phx-col">Check</span>
            <span className="phx-col">5269</span>
            <span className="phx-col">$70.00</span>
            <span className="phx-col">
              <Link href="#">View</Link> | <Link href="#">Change</Link> |{' '}
              <Link href="#">Print</Link> | <Link href="#">Delete</Link>
            </span>
          </div>
          <div className="pymnt-hx-bdy-rw">
            <span className="phx-col">11582</span>
            <span className="phx-col">18-06-2022</span>
            <span className="phx-col">Counseling</span>
            <span className="phx-col">Check</span>
            <span className="phx-col">5269</span>
            <span className="phx-col">$70.00</span>
            <span className="phx-col">
              <Link href="#">View</Link> | <Link href="#">Change</Link> |{' '}
              <Link href="#">Print</Link> | <Link href="#">Delete</Link>
            </span>
          </div>
          <div className="pymnt-hx-bdy-rw alt-rw">
            <span className="phx-col">11001</span>
            <span className="phx-col">12-06-2022</span>
            <span className="phx-col">Counseling</span>
            <span className="phx-col">Check</span>
            <span className="phx-col">5269</span>
            <span className="phx-col">$85.00</span>
            <span className="phx-col">
              <Link href="#">View</Link> | <Link href="#">Change</Link> |{' '}
              <Link href="#">Print</Link> | <Link href="#">Delete</Link>
            </span>
          </div>
          <div className="pymnt-hx-bdy-rw">
            <span className="phx-col">10125</span>
            <span className="phx-col">24-05-2022</span>
            <span className="phx-col">Counseling</span>
            <span className="phx-col">Check</span>
            <span className="phx-col">5269</span>
            <span className="phx-col">$95.00</span>
            <span className="phx-col">
              <Link href="#">View</Link> | <Link href="#">Change</Link> |{' '}
              <Link href="#">Print</Link> | <Link href="#">Delete</Link>
            </span>
          </div>
          <div className="pymnt-hx-bdy-rw alt-rw">
            <span className="phx-col">96588</span>
            <span className="phx-col">17-05-2022</span>
            <span className="phx-col">Counseling</span>
            <span className="phx-col">Check</span>
            <span className="phx-col">5269</span>
            <span className="phx-col">$125.00</span>
            <span className="phx-col">
              <Link href="#">View</Link> | <Link href="#">Change</Link> |{' '}
              <Link href="#">Print</Link> | <Link href="#">Delete</Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentHxPopup;
